import { render, staticRenderFns } from "./AffiliateReserveIndex.vue?vue&type=template&id=2c0f779b&"
import script from "./AffiliateReserveIndex.vue?vue&type=script&lang=js&"
export * from "./AffiliateReserveIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports